import styled from '@emotion/styled';
import { colors } from '@ui-components/neo.tax';
import { Menu as AriaMenu, MenuItem as AriaMenuItem } from 'ariakit';

export const Menu = styled(AriaMenu)({
  padding: 0,
  width: 412,
  borderRadius: '0.375rem',
  backgroundColor: '#FFFFFF',
  boxShadow:
    '#ffffff 0px 0px 0px 0px, #0000000d 0px 0px 0px 1px, #0000001a 0px 10px 15px -3px, #0000001a 0px 4px 6px -4px',
  overflowX: 'hidden',
  outline: 'none',
});

export const MenuItem = styled(AriaMenuItem)({
  color: colors.gray[900],
  fontSize: '0.875rem',
  lineHeight: '1.25rem',
  padding: '0.5rem 1rem',
  cursor: 'pointer',
  whiteSpace: 'nowrap',
  overflowX: 'hidden',
  textOverflow: 'ellipsis',
  outline: 'none',

  // From Ariakit: Item currently selected by mouse hover or keyboard
  '&[data-active-item]': {
    backgroundColor: colors.gray[50],
  },
});

export const MenuItemDivider = styled.div({
  margin: '0.25rem 0',
  borderTop: `1px solid ${colors.gray[200]}`,
});
